import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Cada categoría agrupa vehículos que se cobran igual, con su tarifa de distancia corta y larga.',
    'Se aplica a la flota propia: los viajes de terceros se valorizan con la tarifa del transportista.',
    'Al actualizar una tarifa, los viajes ya registrados conservan el valor con el que se cargaron.',
  ],
  nextSteps: [
    'Asignar la categoría de tarifa a cada vehículo de la flota de transporte.',
    'Consultar el informe de costos de logística para ver el gasto por categoría.',
  ],
};

const ConfiguracionCategoriasLogistica = (props) => (
  <ConfiguracionBase
    apiEndpoint="categorias-logistica"
    titulo="Tarifas Logística"
    descripcion="Categorías de tarifa para la flota de transporte propia"
    icon="fas fa-tag"
    backTo="/configuracion?seccion=logistica"
    compact
    help={HELP}
    {...props}
  />
);

export default ConfiguracionCategoriasLogistica;
